export type Props = {
    tabIndex: number;
    component: React.ReactNode;
    active: boolean;
};

export const TabbedComponent = ({ tabIndex, component, active }: Props) => {
    return (
        <div
            id={ `tab-${tabIndex}` }
            className={ `tab-page ${active ? 'active' : ''}` }
        >
            { component }
        </div>
    );
};
